module.exports = __webpack_public_path__ + "assets/0deff7a43f58b8a586448025752f731b.png";